import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { LOCATION_BASE } from 'bento-ordering/locations/constants/paths';

const useKeepGroupOrderQueryParam = () => {
  const router = useSelector(state => state.router);

  const groupOrderQueryParam = router?.location?.query?.group_order || '';

  const groupOrderRef = useRef(groupOrderQueryParam);
  const history = useHistory();

  const currentPathname = router.location.pathname;

  /**
   * Keeps track of the query_order param at any point in time.
   */
  useEffect(() => {
    if (
      groupOrderQueryParam &&
      groupOrderRef.current !== groupOrderQueryParam
    ) {
      groupOrderRef.current = groupOrderQueryParam;
    }
  }, [currentPathname, groupOrderQueryParam]);

  /**
   * If there is a query_order param it will be add it to the new path
   * except if the current pathname is the location base ('/')
   */
  useEffect(() => {
    if (groupOrderRef.current) {
      if (currentPathname !== LOCATION_BASE) {
        history.replace({
          pathname: currentPathname,
          search: `?group_order=${groupOrderRef.current}`
        });
      } else {
        /**
         * Resetting the group order ref if the current path is the location base ('/')
         * since this path it's not specific to a group order.
         */
        groupOrderRef.current = '';

        history.replace({
          pathname: currentPathname,
          search: ''
        });
      }
    }
  }, [currentPathname, history]);

  return null;
};

export default useKeepGroupOrderQueryParam;
